export const thin = `${1 / 16}rem` as const;
export const tiny = `${2 / 16}rem` as const;
export const xxx_small = `${4 / 16}rem` as const;
export const xx_small = `${6 / 16}rem` as const;
export const x_small = `${8 / 16}rem` as const;
export const small = `${12 / 16}rem` as const;
export const medium = `${16 / 16}rem` as const;
export const large = `${24 / 16}rem` as const;
export const x_large = `${32 / 16}rem` as const;
export const xx_large = `${40 / 16}rem` as const;
export const xxx_large = `${48 / 16}rem` as const;
export const xxxx_large = `${64 / 16}rem` as const;
